import { http, id } from 'utils'
import { SET_ITEMS } from 'vx/mutations'

export default {
  namespaced: true,

  state: {
    firefighters: []
  },

  actions: {
    async getFirefighters ({ commit, state }, { customerId, params = {} } = {}) {
      const response = await http.get(`customers/${id(customerId)}/firefighters`, { params })
      commit(SET_ITEMS, response.data.data)

      return response
    },

    resetFirefighters ({ commit }) {
      commit(SET_ITEMS, [])
    }
  },

  mutations: {
    [SET_ITEMS] (state, items) {
      state.firefighters = items
    }
  }
}
